"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _groupBuy = require("@/api/activity/groupBuy");
var _bonusSend = require("@/api/activity/bonusSend");
var _lottery = require("@/api/activity/lottery");
var _gradeInfo = require("@/api/basic/gradeInfo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 自定义图片上传组件
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fileList: [],
      uploading: false
    };
  },
  watch: {
    value: function value(val) {
      if (val && !this.fileList.length) {
        this.fileList = [{
          name: 'image',
          url: this.getDisplayUrl(val)
        }];
      } else if (!val) {
        this.fileList = [];
      }
    }
  },
  created: function created() {
    if (this.value) {
      this.fileList = [{
        name: 'image',
        url: this.getDisplayUrl(this.value)
      }];
    }
  },
  methods: {
    extractPathPrefix: function extractPathPrefix() {
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (!prefix) return '';
      try {
        if (prefix.startsWith('http://') || prefix.startsWith('https://')) {
          return new URL(prefix).pathname;
        }
      } catch (e) {}
      return prefix;
    },
    getDisplayUrl: function getDisplayUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, relativePath, urlObj, matches, pathPrefix, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _groupBuy.uploadGroupBuyImage)(file);
            case 2:
              res = _context.sent;
              loading.close();
              url = res && res.data || res;
              if (url) {
                relativePath = url;
                if (url.startsWith('http://') || url.startsWith('https://')) {
                  try {
                    urlObj = new URL(url);
                    relativePath = urlObj.pathname;
                  } catch (e) {
                    matches = url.match(/https?:\/\/[^/]+(.+)/);
                    if (matches && matches[1]) {
                      relativePath = matches[1];
                    }
                  }
                }
                pathPrefix = this.extractPathPrefix();
                if (pathPrefix && relativePath.indexOf(pathPrefix) === 0) {
                  relativePath = relativePath.substring(pathPrefix.length);
                }
                relativePath = relativePath.replace(/^\/+/, '');
                this.fileList = [{
                  name: file.name,
                  url: this.getDisplayUrl(relativePath)
                }];
                this.$emit('input', relativePath);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
                this.fileList = [];
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
              this.$message.error('上传失败：' + _t.message);
              this.fileList = [];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.$emit('input', '');
    },
    handlePreview: function handlePreview() {
      if (this.fileList.length > 0) {
        window.open(this.fileList[0].url, '_blank');
      }
    }
  },
  render: function render(h) {
    var _this = this;
    var hasFile = this.fileList.length > 0;
    if (hasFile && !this.disabled) {
      return h('div', {
        class: 'image-upload-container',
        style: {
          position: 'relative',
          display: 'inline-block',
          width: '100px',
          height: '100px'
        }
      }, [h('img', {
        attrs: {
          src: this.fileList[0].url
        },
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '6px',
          border: '1px solid #dcdfe6'
        },
        on: {
          click: this.handlePreview
        }
      }), h('i', {
        class: 'el-icon-close',
        style: {
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: '#909399',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '12px',
          zIndex: 1
        },
        on: {
          click: this.handleRemove
        }
      })]);
    } else {
      var uploadButton = h('el-upload', {
        class: 'image-uploader',
        props: {
          'show-file-list': false,
          'before-upload': this.beforeUpload,
          'http-request': function httpRequest(options) {
            _this.uploadImage(options.file);
          },
          disabled: this.disabled
        }
      }, [h('div', {
        class: 'el-upload el-upload--text',
        style: {
          width: '100px',
          height: '100px',
          border: '1px dashed #d9d9d9',
          borderRadius: '6px',
          cursor: this.disabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fbfdff'
        }
      }, [h('i', {
        class: 'el-icon-plus',
        style: {
          fontSize: '28px',
          color: '#8c939d'
        }
      })])]);
      return h('div', {
        class: 'image-upload-container',
        style: {
          display: 'inline-block'
        }
      }, [uploadButton]);
    }
  }
};
var _default = exports.default = {
  name: 'GroupBuyConfigPane',
  components: {
    ImageUpload: ImageUpload
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      timeRange: [],
      userRankChecked: [],
      launchRankChecked: [],
      attendRankChecked: [],
      userRankOptions: [],
      couponPackagesList: [],
      selectedPackageId: null,
      couponPackagesLoaded: false,
      bonusList: [],
      bonusListLoaded: false,
      selectedCouponId: null,
      originalTotalNum: null,
      itemSpecialUnitPrices: {},
      itemGroupUnitPrices: {},
      form: {
        title: '',
        subTitle: '',
        tag: '',
        mode: 2,
        userType: 0,
        userRank: '',
        isQwe: 0,
        type: 4,
        sid: null,
        marketMoney: 0,
        money: 0,
        groupMoney: 0,
        specialMoney: 0,
        totalNum: 0,
        prePeopleNum: 1,
        startTime: null,
        endTime: null,
        imgUrl: '',
        coverImgUrl: '',
        introImgUrl: '',
        canShare: true,
        shareTitle: '',
        shareImgUrl: '',
        enabled: 1,
        notice: '',
        todayreg: 0,
        jioncoupon: 0,
        userorder: 0,
        expired: 0,
        // 拼团字段
        lbNum: 2,
        lbTime: 60,
        prePeopleLbNum: 1,
        // 团长限制
        launchTodayreg: 0,
        launchJioncoupon: 0,
        launchUserorder: 0,
        launchUserWw: 0,
        launchRank: '',
        // 团员限制
        attendTodayreg: 0,
        attendJioncoupon: 0,
        attendUserorder: 0,
        attendUserWw: 0,
        attendRank: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        tag: [{
          required: true,
          message: '请输入标签',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择购买类型',
          trigger: 'change'
        }],
        groupMoney: [{
          required: true,
          message: '请输入拼团价',
          trigger: 'blur'
        }],
        lbNum: [{
          required: true,
          message: '请输入成团人数',
          trigger: 'blur'
        }],
        lbTime: [{
          required: true,
          message: '请输入拼团有效时长',
          trigger: 'blur'
        }],
        totalNum: [{
          required: true,
          message: '请输入库存数',
          trigger: 'blur'
        }],
        imgUrl: [{
          required: true,
          message: '请上传封面图',
          trigger: 'change'
        }],
        coverImgUrl: [{
          required: true,
          message: '请上传列表图',
          trigger: 'change'
        }],
        introImgUrl: [{
          required: true,
          message: '请上传简介图',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    selectedPackage: function selectedPackage() {
      var _this2 = this;
      if (!this.selectedPackageId) return null;
      return this.couponPackagesList.find(function (pkg) {
        return pkg.id === _this2.selectedPackageId;
      }) || null;
    },
    selectedCoupon: function selectedCoupon() {
      var _this3 = this;
      if (!this.selectedCouponId) return null;
      return this.bonusList.find(function (bonus) {
        return bonus.typeId === _this3.selectedCouponId;
      }) || null;
    },
    isAllUserRanksSelected: function isAllUserRanksSelected() {
      var _this4 = this;
      if (!this.userRankOptions || this.userRankOptions.length === 0) return false;
      return this.userRankOptions.every(function (rank) {
        return _this4.userRankChecked.includes(rank.id);
      });
    },
    isAllLaunchRanksSelected: function isAllLaunchRanksSelected() {
      var _this5 = this;
      if (!this.userRankOptions || this.userRankOptions.length === 0) return false;
      return this.userRankOptions.every(function (rank) {
        return _this5.launchRankChecked.includes(rank.id);
      });
    },
    isAllAttendRanksSelected: function isAllAttendRanksSelected() {
      var _this6 = this;
      if (!this.userRankOptions || this.userRankOptions.length === 0) return false;
      return this.userRankOptions.every(function (rank) {
        return _this6.attendRankChecked.includes(rank.id);
      });
    },
    isEdit: function isEdit() {
      return !!this.id;
    },
    specialPriceConditionMet: function specialPriceConditionMet() {
      return !!(this.form.todayreg || this.form.jioncoupon || this.form.userorder);
    },
    checkedItems: function checkedItems() {
      if (!this.selectedPackage || !this.selectedPackage.items) return [];
      return this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
    },
    itemPurchasePrices: function itemPurchasePrices() {
      var result = {};
      if (!this.selectedPackage || !this.selectedPackage.items) return result;
      var items = this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
      if (items.length === 0) return result;
      var rateType = parseInt(this.selectedPackage.rateType);
      var packagePrice = parseFloat(this.selectedPackage.price) || 0;
      if (rateType === 1 && packagePrice > 0) {
        var totalRateNum = items.reduce(function (sum, item) {
          return sum + (parseFloat(item.rateNum) || 0);
        }, 0);
        if (totalRateNum > 0) {
          var accumulated = 0;
          items.forEach(function (item, index) {
            var rateNum = parseFloat(item.rateNum) || 0;
            if (index === items.length - 1) {
              result[item.id] = Math.round((packagePrice - accumulated) * 100) / 100;
            } else {
              var price = packagePrice * rateNum / totalRateNum;
              var rounded = Math.round(price * 100) / 100;
              result[item.id] = rounded;
              accumulated += rounded;
            }
          });
          return result;
        }
      }
      if (rateType === 2) {
        items.forEach(function (item) {
          var rateNum = parseFloat(item.rateNum) || 0;
          if (rateNum > 0) {
            result[item.id] = rateNum;
          } else {
            result[item.id] = parseFloat(item.oldPrice) || parseFloat(item.money) || 0;
          }
        });
        return result;
      }
      items.forEach(function (item) {
        result[item.id] = parseFloat(item.money) || 0;
      });
      return result;
    },
    // 购买价合计：rateType=1 = 券包购买价；rateType=2 = Σ rateNum × sendNum
    totalPurchasePrice: function totalPurchasePrice() {
      if (!this.selectedPackage) return 0;
      var rateType = parseInt(this.selectedPackage.rateType);
      var items = this.checkedItems;
      if (rateType === 1) {
        return parseFloat(this.selectedPackage.price) || 0;
      }
      if (rateType === 2) {
        var total = 0;
        items.forEach(function (item) {
          var rateNum = parseFloat(item.rateNum) || 0;
          var qty = parseInt(item.sendNum) || 1;
          total += rateNum * qty;
        });
        return Math.round(total * 100) / 100;
      }
      var prices = this.itemPurchasePrices;
      return Object.keys(prices).reduce(function (sum, id) {
        return sum + prices[id];
      }, 0);
    },
    totalSpecialPrice: function totalSpecialPrice() {
      var _this7 = this;
      var total = 0;
      this.checkedItems.forEach(function (item) {
        var unitPrice = parseFloat(_this7.itemSpecialUnitPrices[item.id]) || 0;
        var qty = parseInt(item.sendNum) || 1;
        total += unitPrice * qty;
      });
      return Math.round(total * 100) / 100;
    },
    totalGroupPrice: function totalGroupPrice() {
      var _this8 = this;
      var total = 0;
      this.checkedItems.forEach(function (item) {
        var unitPrice = parseFloat(_this8.itemGroupUnitPrices[item.id]) || 0;
        var qty = parseInt(item.sendNum) || 1;
        total += unitPrice * qty;
      });
      return Math.round(total * 100) / 100;
    },
    showSpecialPriceColumn: function showSpecialPriceColumn() {
      return this.specialPriceConditionMet;
    }
  },
  watch: {
    selectedPackageId: function selectedPackageId(newVal) {
      var _this9 = this;
      if (!newVal) return;
      this.$nextTick(function () {
        if (_this9.selectedPackage && _this9.selectedPackage.items) {
          _this9.handlePackageChange(newVal);
          if (_this9.id && _this9.form.type === 4 && !_this9._specialPricesInited) {
            _this9._specialPricesInited = true;
            // 优先使用已保存的明细价格，没有时才按比例重新分配
            if (_this9._loadedDetails && _this9._loadedDetails.length > 0) {
              var detailMap = {};
              _this9._loadedDetails.forEach(function (d) {
                detailMap[d.itemId] = d;
              });
              _this9.selectedPackage.items.forEach(function (item) {
                var d = detailMap[item.id];
                if (d) {
                  _this9.$set(_this9.itemGroupUnitPrices, item.id, parseFloat(d.groupMoney) || 0);
                  _this9.$set(_this9.itemSpecialUnitPrices, item.id, parseFloat(d.specialMoney) || 0);
                } else {
                  _this9.$set(_this9.itemGroupUnitPrices, item.id, 0);
                  _this9.$set(_this9.itemSpecialUnitPrices, item.id, 0);
                }
              });
              _this9._loadedDetails = null;
            } else {
              _this9.redistributeGroupUnitPrices();
              _this9.redistributeSpecialUnitPrices();
            }
          }
        }
      });
    },
    userRankChecked: function userRankChecked(val) {
      this.form.userRank = (0, _toConsumableArray2.default)(val).sort().join(',');
    },
    launchRankChecked: function launchRankChecked(val) {
      this.form.launchRank = (0, _toConsumableArray2.default)(val).sort().join(',');
    },
    attendRankChecked: function attendRankChecked(val) {
      this.form.attendRank = (0, _toConsumableArray2.default)(val).sort().join(',');
    },
    'form.userType': function formUserType(newVal) {
      if (newVal === 1) {
        this.userRankChecked = [];
      } else if (!this.userRankChecked || this.userRankChecked.length === 0) {
        if (!this.isEdit) {
          this.userRankChecked = this.userRankOptions.map(function (rank) {
            return rank.id;
          });
        }
      }
    },
    'form.type': function formType(newVal) {
      var _this0 = this;
      if (!this.id) {
        this.form.marketMoney = 0;
        this.form.money = 0;
      }
      if (newVal === 4) {
        this.selectedCouponId = null;
        if (this.selectedPackage && this.selectedPackage.items) {
          this.selectedPackage.items.forEach(function (item) {
            _this0.$set(item, 'checked', true);
            _this0.$set(item, 'disabled', true);
          });
          if (!this.id) {
            if (this.selectedPackage.oldPrice != null) {
              this.form.marketMoney = this.selectedPackage.oldPrice;
            }
            if (this.selectedPackage.price != null) {
              this.form.money = this.selectedPackage.price;
            }
          }
        }
      } else {
        this.selectedPackageId = null;
      }
    },
    specialPriceConditionMet: function specialPriceConditionMet(val) {
      if (!val) {
        this.form.specialMoney = 0;
      } else if (this.form.type === 4) {
        this.form.specialMoney = this.totalSpecialPrice;
      }
    },
    totalSpecialPrice: function totalSpecialPrice(newVal) {
      if (this._isRedistributing) return;
      if (this.specialPriceConditionMet && this.form.type === 4) {
        this.form.specialMoney = newVal;
      }
    },
    totalGroupPrice: function totalGroupPrice(newVal) {
      if (this._isRedistributingGroup) return;
      if (this.form.type === 4) {
        this.form.groupMoney = newVal;
      }
    }
  },
  created: function created() {
    this._isRedistributing = false;
    this._isRedistributingGroup = false;
    this.loadUserRankOptions();
    this.loadCouponPackages();
    this.loadBonusList();
    if (this.id) {
      this.fetchDetail();
    }
  },
  methods: {
    fetchDetail: function fetchDetail() {
      var _this1 = this;
      this.loading = true;
      (0, _groupBuy.getGroupBuyDetail)(this.id).then(function (response) {
        var data = response.data;

        // 保存券明细价格列表，供券包加载完成后使用
        _this1._loadedDetails = data.details || [];
        Object.keys(_this1.form).forEach(function (key) {
          if (data[key] !== undefined && data[key] !== null) {
            _this1.form[key] = data[key];
          }
        });
        _this1.originalTotalNum = data.totalNum;
        if (data.startTime && data.endTime) {
          _this1.timeRange = [data.startTime, data.endTime];
        }
        if (data.userRank) {
          _this1.userRankChecked = data.userRank.split(',').map(Number);
        }
        if (data.launchRank) {
          _this1.launchRankChecked = data.launchRank.split(',').map(Number);
        }
        if (data.attendRank) {
          _this1.attendRankChecked = data.attendRank.split(',').map(Number);
        }
        if (data.sid) {
          if (_this1.form.type === 4) {
            _this1.waitForCouponPackages().then(function () {
              var matchedPackage = _this1.couponPackagesList.find(function (pkg) {
                return String(pkg.id) === String(data.sid) || pkg.id === parseInt(data.sid);
              });
              if (matchedPackage) {
                _this1.selectedPackageId = matchedPackage.id;
              }
            });
          } else if (_this1.form.type === 5) {
            _this1.waitForBonusList().then(function () {
              var matchedCoupon = _this1.bonusList.find(function (coupon) {
                return String(coupon.typeId) === String(data.sid) || coupon.typeId === parseInt(data.sid);
              });
              if (matchedCoupon) {
                _this1.selectedCouponId = matchedCoupon.typeId;
              }
            });
          }
        }
        _this1.loading = false;
      }).catch(function () {
        _this1.loading = false;
      });
    },
    loadUserRankOptions: function () {
      var _loadUserRankOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.userRankOptions = response.records.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                });
                if (!this.id && this.userRankChecked.length === 0) {
                  this.userRankChecked = this.userRankOptions.map(function (rank) {
                    return rank.id;
                  });
                }
                // 新建时团长等级和团员等级默认全选
                if (!this.id) {
                  this.launchRankChecked = this.userRankOptions.map(function (rank) {
                    return rank.id;
                  });
                  this.attendRankChecked = this.userRankOptions.map(function (rank) {
                    return rank.id;
                  });
                }
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取用户级别列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadUserRankOptions() {
        return _loadUserRankOptions.apply(this, arguments);
      }
      return loadUserRankOptions;
    }(),
    loadCouponPackages: function () {
      var _loadCouponPackages = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _bonusSend.getCouponPackagesWithItems)();
            case 1:
              response = _context3.sent;
              if (response.code === 200 && response.data) {
                this.couponPackagesList = response.data;
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('加载券包数据失败:', _t3);
            case 3:
              _context3.prev = 3;
              this.couponPackagesLoaded = true;
              return _context3.finish(3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2, 3, 4]]);
      }));
      function loadCouponPackages() {
        return _loadCouponPackages.apply(this, arguments);
      }
      return loadCouponPackages;
    }(),
    waitForCouponPackages: function waitForCouponPackages() {
      var _this10 = this;
      return new Promise(function (resolve) {
        if (_this10.couponPackagesLoaded) {
          resolve();
        } else {
          var checkInterval = setInterval(function () {
            if (_this10.couponPackagesLoaded) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          setTimeout(function () {
            clearInterval(checkInterval);
            resolve();
          }, 5000);
        }
      });
    },
    waitForBonusList: function waitForBonusList() {
      var _this11 = this;
      return new Promise(function (resolve) {
        if (_this11.bonusListLoaded) {
          resolve();
        } else {
          var checkInterval = setInterval(function () {
            if (_this11.bonusListLoaded) {
              clearInterval(checkInterval);
              resolve();
            }
          }, 100);
          setTimeout(function () {
            clearInterval(checkInterval);
            resolve();
          }, 5000);
        }
      });
    },
    loadBonusList: function () {
      var _loadBonusList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _lottery.getBonusList)();
            case 1:
              response = _context4.sent;
              if (response.code === 200 && response.data) {
                this.bonusList = response.data;
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              console.error('加载优惠券列表失败:', _t4);
            case 3:
              _context4.prev = 3;
              this.bonusListLoaded = true;
              return _context4.finish(3);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2, 3, 4]]);
      }));
      function loadBonusList() {
        return _loadBonusList.apply(this, arguments);
      }
      return loadBonusList;
    }(),
    handlePackageChange: function handlePackageChange(packageId) {
      var _this12 = this;
      if (!packageId) return;
      var pkg = this.couponPackagesList.find(function (p) {
        return p.id === packageId;
      });
      if (pkg && pkg.items) {
        pkg.items.forEach(function (item, index) {
          if (_this12.form.type === 4) {
            _this12.$set(item, 'checked', true);
            _this12.$set(item, 'disabled', true);
            if (!_this12.id) {
              if (pkg.oldPrice != null) {
                _this12.form.marketMoney = pkg.oldPrice;
              }
              if (pkg.price != null) {
                _this12.form.money = pkg.price;
                if (!_this12.form.groupMoney) {
                  _this12.form.groupMoney = pkg.price;
                }
              }
            }
          } else {
            _this12.$set(item, 'checked', index === 0);
            _this12.$set(item, 'disabled', false);
          }
          _this12.$set(item, 'sendNum', item.sendNum || 0);
          if (!_this12.itemSpecialUnitPrices.hasOwnProperty(item.id)) {
            _this12.$set(_this12.itemSpecialUnitPrices, item.id, 0);
          }
          if (!_this12.itemGroupUnitPrices.hasOwnProperty(item.id)) {
            _this12.$set(_this12.itemGroupUnitPrices, item.id, 0);
          }
        });
      }
    },
    handleCouponChange: function handleCouponChange(couponId) {
      // 单品券选择
    },
    handleSelectAllUserRanks: function handleSelectAllUserRanks() {
      this.userRankChecked = this.isAllUserRanksSelected ? [] : this.userRankOptions.map(function (rank) {
        return rank.id;
      });
    },
    handleSelectAllLaunchRanks: function handleSelectAllLaunchRanks() {
      this.launchRankChecked = this.isAllLaunchRanksSelected ? [] : this.userRankOptions.map(function (rank) {
        return rank.id;
      });
    },
    handleSelectAllAttendRanks: function handleSelectAllAttendRanks() {
      this.attendRankChecked = this.isAllAttendRanksSelected ? [] : this.userRankOptions.map(function (rank) {
        return rank.id;
      });
    },
    formatPrice: function formatPrice(val) {
      var num = parseFloat(val) || 0;
      return num.toFixed(2);
    },
    redistributeSpecialUnitPrices: function redistributeSpecialUnitPrices() {
      var _this13 = this;
      if (!this.selectedPackage || !this.selectedPackage.items) return;
      if (this.form.type !== 4) return;
      var items = this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
      var totalSpecial = parseFloat(this.form.specialMoney) || 0;
      if (totalSpecial <= 0 || items.length === 0) {
        this.selectedPackage.items.forEach(function (item) {
          _this13.$set(_this13.itemSpecialUnitPrices, item.id, 0);
        });
        return;
      }
      var prices = this.itemPurchasePrices;
      var totalPurchase = Object.keys(prices).reduce(function (sum, id) {
        return sum + prices[id];
      }, 0);
      var accumulated = 0;
      items.forEach(function (item, index) {
        var sendNum = parseInt(item.sendNum) || 1;
        var itemTotal;
        if (totalPurchase <= 0) {
          itemTotal = index === items.length - 1 ? Math.round((totalSpecial - accumulated) * 100) / 100 : Math.round(totalSpecial / items.length * 100) / 100;
        } else {
          var itemPrice = prices[item.id] || 0;
          if (index === items.length - 1) {
            itemTotal = Math.round((totalSpecial - accumulated) * 100) / 100;
          } else {
            itemTotal = Math.round(totalSpecial * (itemPrice / totalPurchase) * 100) / 100;
          }
        }
        accumulated += itemTotal;
        var unitPrice = Math.round(itemTotal / sendNum * 100) / 100;
        _this13.$set(_this13.itemSpecialUnitPrices, item.id, unitPrice);
      });
    },
    handleSpecialMoneyChange: function handleSpecialMoneyChange() {
      var _this14 = this;
      if (this.form.type === 4 && this.specialPriceConditionMet) {
        this._isRedistributing = true;
        this.redistributeSpecialUnitPrices();
        this.$nextTick(function () {
          _this14._isRedistributing = false;
        });
      }
    },
    redistributeGroupUnitPrices: function redistributeGroupUnitPrices() {
      var _this15 = this;
      if (!this.selectedPackage || !this.selectedPackage.items) return;
      if (this.form.type !== 4) return;
      var items = this.selectedPackage.items.filter(function (item) {
        return item.checked;
      });
      var totalGroup = parseFloat(this.form.groupMoney) || 0;
      if (totalGroup <= 0 || items.length === 0) {
        this.selectedPackage.items.forEach(function (item) {
          _this15.$set(_this15.itemGroupUnitPrices, item.id, 0);
        });
        return;
      }
      var prices = this.itemPurchasePrices;
      var totalPurchase = Object.keys(prices).reduce(function (sum, id) {
        return sum + prices[id];
      }, 0);
      var accumulated = 0;
      items.forEach(function (item, index) {
        var sendNum = parseInt(item.sendNum) || 1;
        var itemTotal;
        if (totalPurchase <= 0) {
          itemTotal = index === items.length - 1 ? Math.round((totalGroup - accumulated) * 100) / 100 : Math.round(totalGroup / items.length * 100) / 100;
        } else {
          var itemPrice = prices[item.id] || 0;
          if (index === items.length - 1) {
            itemTotal = Math.round((totalGroup - accumulated) * 100) / 100;
          } else {
            itemTotal = Math.round(totalGroup * (itemPrice / totalPurchase) * 100) / 100;
          }
        }
        accumulated += itemTotal;
        var unitPrice = Math.round(itemTotal / sendNum * 100) / 100;
        _this15.$set(_this15.itemGroupUnitPrices, item.id, unitPrice);
      });
    },
    handleGroupMoneyChange: function handleGroupMoneyChange() {
      var _this16 = this;
      if (this.form.type === 4) {
        this._isRedistributingGroup = true;
        this.redistributeGroupUnitPrices();
        this.$nextTick(function () {
          _this16._isRedistributingGroup = false;
        });
      }
    },
    handleSubmit: function handleSubmit() {
      var _this17 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(valid) {
          var checkedItems, finalPrice, formData, details, _t5, _t6, _t7;
          return regeneratorRuntime.wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (valid) {
                  _context5.next = 1;
                  break;
                }
                return _context5.abrupt("return");
              case 1:
                if (!(!_this17.timeRange || _this17.timeRange.length !== 2)) {
                  _context5.next = 2;
                  break;
                }
                _this17.$message.error('请选择购买时间');
                return _context5.abrupt("return");
              case 2:
                if (!(!_this17.form.lbNum || _this17.form.lbNum < 2)) {
                  _context5.next = 3;
                  break;
                }
                _this17.$message.error('成团人数不能少于2人');
                return _context5.abrupt("return");
              case 3:
                if (!(_this17.form.type === 4 && !_this17.selectedPackageId)) {
                  _context5.next = 4;
                  break;
                }
                _this17.$message.error('请选择券包');
                return _context5.abrupt("return");
              case 4:
                if (!(_this17.form.type === 5 && !_this17.selectedCouponId)) {
                  _context5.next = 5;
                  break;
                }
                _this17.$message.error('请选择优惠券');
                return _context5.abrupt("return");
              case 5:
                if (!(_this17.form.type === 4 && _this17.selectedPackage && _this17.selectedPackage.items)) {
                  _context5.next = 6;
                  break;
                }
                checkedItems = _this17.selectedPackage.items.filter(function (item) {
                  return item.checked;
                });
                if (!(checkedItems.length === 0)) {
                  _context5.next = 6;
                  break;
                }
                _this17.$message.error('请至少选择一张券');
                return _context5.abrupt("return");
              case 6:
                if (!(_this17.isEdit && _this17.form.totalNum != null && _this17.originalTotalNum != null)) {
                  _context5.next = 7;
                  break;
                }
                if (!(_this17.form.totalNum < _this17.originalTotalNum)) {
                  _context5.next = 7;
                  break;
                }
                _this17.$message.error('库存只能增加不能减少');
                return _context5.abrupt("return");
              case 7:
                finalPrice = parseFloat(_this17.form.groupMoney) || 0;
                if (!(finalPrice === 0)) {
                  _context5.next = 11;
                  break;
                }
                _context5.prev = 8;
                _context5.next = 9;
                return _this17.$confirm('拼团价格设置为0将免费发放，确认要继续吗？', '价格警告', {
                  confirmButtonText: '确认免费发放',
                  cancelButtonText: '取消',
                  type: 'warning',
                  distinguishCancelAndClose: true
                });
              case 9:
                _context5.next = 11;
                break;
              case 10:
                _context5.prev = 10;
                _t5 = _context5["catch"](8);
                return _context5.abrupt("return");
              case 11:
                if (_this17.specialPriceConditionMet) {
                  _context5.next = 12;
                  break;
                }
                _this17.form.specialMoney = 0;
                _context5.next = 16;
                break;
              case 12:
                if (!(parseFloat(_this17.form.specialMoney) === 0)) {
                  _context5.next = 16;
                  break;
                }
                _context5.prev = 13;
                _context5.next = 14;
                return _this17.$confirm('当前已启用特惠条件但特惠价格设置为0，确认要继续吗？', '特惠价格确认', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'warning',
                  distinguishCancelAndClose: true
                });
              case 14:
                _context5.next = 16;
                break;
              case 15:
                _context5.prev = 15;
                _t6 = _context5["catch"](13);
                return _context5.abrupt("return");
              case 16:
                formData = _objectSpread({}, _this17.form);
                formData.userRank = (0, _toConsumableArray2.default)(_this17.userRankChecked).sort().join(',');
                formData.launchRank = (0, _toConsumableArray2.default)(_this17.launchRankChecked).sort().join(',');
                formData.attendRank = (0, _toConsumableArray2.default)(_this17.attendRankChecked).sort().join(',');
                if (_this17.timeRange && _this17.timeRange.length === 2) {
                  formData.startTime = _this17.timeRange[0];
                  formData.endTime = _this17.timeRange[1];
                }
                if (_this17.form.type === 4 && _this17.selectedPackage) {
                  formData.sid = _this17.selectedPackageId;
                  if (_this17.selectedPackage.oldPrice != null) {
                    formData.marketMoney = _this17.selectedPackage.oldPrice;
                  }
                  if (_this17.selectedPackage.price != null) {
                    formData.money = _this17.selectedPackage.price;
                  }

                  // 构建券明细价格列表
                  details = [];
                  _this17.selectedPackage.items.filter(function (item) {
                    return item.checked;
                  }).forEach(function (item) {
                    details.push({
                      itemId: item.id,
                      crmCouponId: item.crmCouponId,
                      groupMoney: _this17.itemGroupUnitPrices[item.id] || 0,
                      specialMoney: _this17.itemSpecialUnitPrices[item.id] || 0
                    });
                  });
                  formData.details = details;
                } else if (_this17.form.type === 5 && _this17.selectedCoupon) {
                  formData.sid = _this17.selectedCoupon.typeId;
                }
                if (_this17.id) {
                  formData.id = _this17.id;
                }
                _this17.loading = true;
                _context5.prev = 17;
                _context5.next = 18;
                return (0, _groupBuy.saveGroupBuy)(formData);
              case 18:
                _this17.$message.success('保存成功');
                _this17.$emit('success');
                _context5.next = 20;
                break;
              case 19:
                _context5.prev = 19;
                _t7 = _context5["catch"](17);
                _this17.$message.error('保存失败');
              case 20:
                _context5.prev = 20;
                _this17.loading = false;
                return _context5.finish(20);
              case 21:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[8, 10], [13, 15], [17, 19, 20, 21]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};